import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainerSmall } from '@/components/ContentContainer';
import { useTypedSelector } from '@/store/store';
import { selectDealer } from '@/store/reducers/single-dealer';
import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';

import Service from './components/Service';

function Services() {
  const dealer = useTypedSelector(selectDealer);

  if (!dealer || !dealer.locations || dealer.locations.length === 0) {
    return null;
  }

  return (
    <Component id="services">
      <ContentContainerSmall>
        {dealer.locations.map(({ divisions, name }, index) => (
          <React.Fragment key={index}>
            {dealer.locations.length > 1 && <Name>{name}</Name>}
            <Cards>
              {divisions &&
                divisions.length !== 0 &&
                divisions.map(({ name, phones, workTime }, index) => (
                  <Service
                    key={index}
                    name={name ?? ''}
                    phones={phones}
                    workTime={workTime ? workTime.split(',') : []}
                  />
                ))}
            </Cards>
          </React.Fragment>
        ))}

        {dealer.text && (
          <Text dangerouslySetInnerHTML={{ __html: dealer.text }} />
        )}
      </ContentContainerSmall>
    </Component>
  );
}

export default Services;

const Component = styled.section`
  padding: 20px 0;

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0;
    `)}
  }
`;

const Name = styled.p`
  font-weight: 700;
  font-size: 26px;
  line-height: 34px;
  color: ${colors.main};

  &:not(:first-child) {
    margin-top: 10px;
  }

  ${media.tablet(
    css`
      font-size: 24px;
      line-height: 30px;
      margin: 0 20px;
    `
  )}
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  ${media.tablet(css`
    grid-template-columns: repeat(2, 1fr);
  `)}

  ${media.mobile(css`
    grid-template-columns: repeat(1, 1fr);
  `)}
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 19px;
  margin-top: 20px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    margin: 20px 20px 0;
  `)}
`;
